import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, notification, Button } from "antd";
import { RedoOutlined } from "@ant-design/icons";
import { useProjectState } from "../../../context/stateContext";
import organizationActions from "../../../redux/organizations/actions";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import qrActions from "../../../redux/qr/actions";
import menuConfigurationActions from "../../../redux/menuConfiguration/actions";
import QRManagementSelect from "../../../components/User/QRManagementComponent/QRManagementSelect";
import QRManagementTable from "../../../components/User/QRManagementComponent/QRManagementTable";
import QRManagementScanner from "../../../components/User/QRManagementComponent/QRManagementScanner";
import QRManagementModal from "../../../components/User/QRManagementComponent/QRManagementModal";
import QRManagementSearch from "../../../components/User/QRManagementComponent/QRManagementSearch";
import "./index.css";

const { getRestaurants, setSelectedRestaurant } = appActions;
const { getMenuConfiguration } = organizationActions;
const { syncMenuConfigurationImages, loadingSyncImages } =
  menuConfigurationActions;

const {
  getQRTables,
  toggleScanModal,
  saveQRTable,
  createQRTable,
  getTouchSaleTables,
  changeExistQrCode,
} = qrActions;

function QRManagement() {
  const [searchedValue, setSearchedValue] = useState("");
  const { showScanModal, scannedQRTable, tableScanStatus } = useSelector(
    (state) => state.qrReducer
  );

  const { selectedOrganization } = useProjectState();

  const { restaurants, selectedRestaurant, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const dispatch = useDispatch();

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  useEffect(() => {
    dispatch(getMenuConfiguration());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;

  useEffect(() => {
    dispatch(
      setSelectedRestaurant(
        defaultOrganization[0]?.defaultTouchSaleRestaurantId
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  useEffect(() => {
    if (!showScanModal) return; // If the modal is not open it does nothing
    if (localStorage.getItem("restaurantId")) {
      dispatch(getRestaurants());
      dispatch(getTouchSaleTables());
    } else {
      notification["error"]({
        message: "Няма конфигурирани маси в TouchSale",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, showScanModal]);

  useEffect(() => {
    dispatch(getQRTables());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showScanModal]);

  const validateSaveQRTable = () => {
    // tableScanStatus - 0 is new code
    // tableScanStatus - 1 is old code
    // tableScanStatus - 2 change the old one

    if (
      scannedQRTable.name.length <= 0 ||
      scannedQRTable.touchSaleTableId === undefined
    ) {
      notification["error"]({
        message: "Моля изберете маса",
      });

      return;
    }
    if (scannedQRTable.name.restaurantId === 0) {
      notification["error"]({
        message: "Моля изберете ресторант",
      });
    }
    if (tableScanStatus === 0 || tableScanStatus === 1) {
      scannedQRTable.restaurantId = parseInt(
        localStorage.getItem("restaurantId")
      );
    }
    if (tableScanStatus === 1 || tableScanStatus === 2) {
      dispatch(saveQRTable(scannedQRTable));
    } else {
      scannedQRTable.restaurantName = restaurants.filter(
        (r) => r.id === selectedRestaurant
      )[0].name;
      dispatch(createQRTable(scannedQRTable));
      dispatch(toggleScanModal());
    }
  };

  return (
    <div>
      <div className="qr-management-custom-header-container">
        <div className="qr-management-custom-header">QR Кодове</div>
        <Button
          id="qr-management-header-button"
          icon={<RedoOutlined />}
          onClick={() => {
            dispatch(loadingSyncImages());
            dispatch(
              syncMenuConfigurationImages(
                localStorage.getItem("organizationId")
              )
            );
          }}
        >
          Опресни меню
        </Button>
      </div>
      <QRManagementSelect key="QRManagementSelect" />
      <QRManagementSearch setSearchedValue={setSearchedValue} />
      <QRManagementTable
        key="QRManagementTable"
        searchedValue={searchedValue}
      />
      <Modal
        title={
          <p className="qr-management-title">Свързване на QR код с маса</p>
        }
        className="modal-container"
        key="4"
        centered
        bodyStyle={{ padding: "0", margin: "0" }}
        open={showScanModal}
        onOk={() => validateSaveQRTable()}
        // onCancel={() => dispatch(toggleScanModal())}
        footer={null}
      >
        <QRManagementScanner key="QRManagementScanner" />
        <QRManagementModal key="QRManagementModal" />
        {tableScanStatus === 1 ? (
          <div className="modal-container-btn-container">
            <Button
              id="modal-container-btn-cancel"
              onClick={() => dispatch(toggleScanModal())}
            >
              Не
            </Button>
            <Button
              id="modal-container-btn-okey"
              type="primary"
              onClick={() => {
                dispatch(changeExistQrCode());
              }}
            >
              Да
            </Button>
          </div>
        ) : (
          <div className="modal-container-btn-container">
            <Button
              id="modal-container-btn-cancel"
              onClick={() => dispatch(toggleScanModal())}
            >
              Отказ
            </Button>
            <Button
              id="modal-container-btn-okey"
              type="primary"
              onClick={() => {
                validateSaveQRTable();
              }}
            >
              Запази
            </Button>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default QRManagement;
